<ideal-wire-cut-item-description [itemId]="id()" />
<ideal-cart-item-price-view [itemId]="id()" [quantity]="quantity() * customLength()" />
